<template>
  <div class="pre-launch">
    <div class="pre-launch-backdrop" />

    <div
      class="pre-launch-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="preLaunchTitle"
      data-testid="pre-launch-modal"
    >
      <img
        class="pre-launch-logo"
        src="../assets/images/logo-videomedi.png"
        alt="Videomedi"
      />

      <h1 id="preLaunchTitle" class="pre-launch-title">
        {{ title }}
      </h1>

      <p class="pre-launch-text">
        {{ message }}
      </p>

      <div class="pre-launch-actions">
        <router-link
          v-if="!loggedIn"
          class="pre-launch-button pre-launch-button-primary"
          :to="registerPatientRoute"
          data-testid="pre-launch-patient"
        >
          Me cadastrar como paciente
        </router-link>

        <router-link
          v-if="!loggedIn"
          class="pre-launch-button pre-launch-button-primary"
          :to="registerProfessionalRoute"
          data-testid="pre-launch-professional"
        >
          Me cadastrar como profissional de saúde
        </router-link>

        <router-link
          v-if="!loggedIn"
          class="pre-launch-button pre-launch-button-ghost"
          :to="loginRoute"
          data-testid="pre-launch-login"
        >
          Já tenho uma conta / Entrar
        </router-link>

        <button
          v-else
          type="button"
          class="pre-launch-button pre-launch-button-ghost"
          data-testid="pre-launch-logout"
          @click="logout"
        >
          Sair
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Espelham PreLaunch::ACCOUNT_MESSAGE e PreLaunch::VISITOR_MESSAGE do backend.
// "Seu cadastro já está pronto" só vale para quem tem conta; o visitante
// anônimo recebe o convite a se cadastrar.
const DEFAULT_ACCOUNT_MESSAGE =
  "Estamos preparando os últimos detalhes da nova Videomedi. " +
  "A plataforma estará disponível a partir da segunda metade de setembro. " +
  "Seu cadastro já está pronto e você poderá utilizar a Videomedi assim que " +
  "o acesso for liberado.";

const DEFAULT_VISITOR_MESSAGE =
  "Estamos preparando os últimos detalhes da nova Videomedi. " +
  "A plataforma estará disponível a partir da segunda metade de setembro. " +
  "Cadastre-se agora e sua conta estará pronta assim que o acesso for liberado.";

export default {
  name: "PreLaunchView",
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    }
  },
  computed: {
    // Os três destinos do pré-lançamento apontam para os fluxos REAIS já
    // existentes — não há cadastro paralelo.
    registerPatientRoute() {
      return { name: "Register" };
    },

    registerProfessionalRoute() {
      return { name: "Register", query: { type: "doctor" } };
    },

    loginRoute() {
      return { name: "Login" };
    },

    loggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    title() {
      return this.loggedIn
        ? "Cadastro realizado com sucesso!"
        : "A nova Videomedi está chegando";
    },
    // O texto é servido pelo backend justamente para poder ser ajustado sem
    // deploy do frontend; o default cobre o caso de status indisponível.
    message() {
      return (
        this.$store.getters["preLaunch/preLaunchMessage"] || this.defaultMessage
      );
    },

    defaultMessage() {
      return this.loggedIn ? DEFAULT_ACCOUNT_MESSAGE : DEFAULT_VISITOR_MESSAGE;
    }
  }
};
</script>

<style lang="scss" scoped>
.pre-launch {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-6, 1.5rem);
  position: relative;
}

.pre-launch-backdrop {
  background: linear-gradient(160deg, #0f172a 0%, #1352c4 100%);
  inset: 0;
  position: fixed;
}

.pre-launch-modal {
  background-color: var(--color-bg-card, #ffffff);
  border-radius: var(--radius-xl, 1rem);
  box-shadow: var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12));
  max-width: 520px;
  padding: var(--space-10, 2.5rem);
  position: relative;
  text-align: center;
  width: 100%;
}

.pre-launch-logo {
  height: 40px;
  margin-bottom: var(--space-6, 1.5rem);
}

.pre-launch-title {
  color: var(--color-gray-900, #0f172a);
  font-size: var(--font-size-2xl, 1.5rem);
  font-weight: var(--fw-bold, 700);
  margin-bottom: var(--space-4, 1rem);
}

.pre-launch-text {
  color: var(--color-gray-600, #475569);
  font-size: var(--font-size-md, 1rem);
  line-height: 1.6;
  margin-bottom: var(--space-8, 2rem);
}

.pre-launch-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-3, 0.75rem);
}

.pre-launch-button {
  border: 1px solid transparent;
  border-radius: var(--radius-md, 0.5rem);
  cursor: pointer;
  display: block;
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--fw-semibold, 600);
  padding: var(--space-3, 0.75rem) var(--space-5, 1.25rem);
  text-decoration: none;
  transition: all 0.2s ease;
  width: 100%;
}

.pre-launch-button-primary {
  background-color: var(--color-primary, #1a6cf7);
  color: #ffffff;
}

.pre-launch-button-primary:hover {
  background-color: var(--color-primary-dark, #1352c4);
  color: #ffffff;
}

.pre-launch-button-ghost {
  background-color: transparent;
  border-color: var(--color-gray-300, #cbd5e1);
  color: var(--color-gray-700, #334155);
}

.pre-launch-button-ghost:hover {
  background-color: var(--color-gray-100, #f1f5f9);
  color: var(--color-gray-900, #0f172a);
}
</style>
